<template>
  <div class="property-banner">
    <img :src="residentBanner" alt="" />
    <div class="absolute">
      <div class="title">业主APP、小程序</div>
      <div class="text">
        一机在手，满足业主各项需求，一键轻松解决问题，实现智能化社区生活服务平台，提升业主幸福感。
      </div>
      <div class="experience" @click="experienceClick">立即体验</div>
    </div>
  </div>
  <Experience
    v-if="experienceShow"
    :experienceShow="experienceShow"
    @experienceClick="experienceClick"
  ></Experience>
</template>

<script>
import { reactive } from "vue";

import Experience from "../../../../components/pc/components/Experience.vue";

import residentBanner from "../../../../assets/product/residentBanner.png";

export default {
  setup() {
    return reactive({
      residentBanner: residentBanner,
      experienceShow: false,
    });
  },
  components: {
    Experience,
  },
  methods: {
    experienceClick() {
      this.experienceShow = !this.experienceShow;
    },
  },
};
</script>

<style scoped>
.property-banner {
  position: relative;
}
@media screen and (max-width: 1180px) {
  .property-banner {
    min-width: 1180px;
  }
}
.property-banner img {
  width: 100%;
  height: 628px;
}
.absolute {
  position: absolute;
  top: 30%;
  left: 33%;
  transform: translate(-50%, -50%);
}
.absolute .title {
  font-size: 30px;
  color: #fff;
}
.absolute .text {
  width: 490px;
  font-size: 14px;
  margin-top: 30px;
  color: #fff;
}
.absolute .experience {
  margin-top: 60px;
  font-size: 16px;
  color: #fff;
  width: 108px;
  height: 36px;
  line-height: 36px;
  border: 1px solid #fff;
  border-radius: 6px 6px 6px 6px;
  text-align: center;
  cursor: pointer;
}
</style>
